import Vue from 'vue'
import VueRouter from 'vue-router'
import Document from '../views/Document.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Document',
    component: Document
  },
  {
    path: '/about',
    name: 'WebClient',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/WebClient.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
